import { render } from "./Methodology.vue?vue&type=template&id=5d8bc5a9&scoped=true"
import script from "./Methodology.vue?vue&type=script&setup=true&lang=js"
export * from "./Methodology.vue?vue&type=script&setup=true&lang=js"

import "./Methodology.vue?vue&type=style&index=0&id=5d8bc5a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8bc5a9"],['__file',"src/components/Paragraphs/Methodology.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d8bc5a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d8bc5a9', __exports__)) {
    api.reload('5d8bc5a9', __exports__)
  }
  
  module.hot.accept("./Methodology.vue?vue&type=template&id=5d8bc5a9&scoped=true", () => {
    api.rerender('5d8bc5a9', render)
  })

}


export default __exports__